webpackJsonp([2714588693513033000],{

/***/ "./src/components/University.jsx":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__("./src/components/University.scss");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var University = function University(_ref) {
	  var degree = _ref.degree,
	      duration = _ref.duration,
	      link = _ref.link,
	      location = _ref.location,
	      name = _ref.name;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'university' },
	    _react2.default.createElement(
	      'h2',
	      { className: 'university__name' },
	      _react2.default.createElement(
	        'a',
	        { href: link },
	        name
	      )
	    ),
	    _react2.default.createElement(
	      'p',
	      { className: 'university__degree' },
	      degree
	    ),
	    _react2.default.createElement(
	      'p',
	      { className: 'university__location' },
	      location
	    ),
	    _react2.default.createElement(
	      'p',
	      { className: 'university__duration' },
	      duration
	    )
	  );
	};
	
	exports.default = University;
	module.exports = exports['default'];

/***/ }),

/***/ "./src/components/University.scss":
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/Users/mark/Sites/Personal/markgaucher/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/Users/mark/Sites/Personal/markgaucher/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/mark/Sites/Personal/markgaucher/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/mark/Sites/Personal/markgaucher/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"presets\":[\"/Users/mark/Sites/Personal/markgaucher/node_modules/babel-preset-env/lib/index.js\",\"/Users/mark/Sites/Personal/markgaucher/node_modules/babel-preset-stage-0/lib/index.js\",\"/Users/mark/Sites/Personal/markgaucher/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/education.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _University = __webpack_require__("./src/components/University.jsx");
	
	var _University2 = _interopRequireDefault(_University);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Education = function Education(_ref) {
	  var items = _ref.items;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'ul',
	      { className: 'education__list list-transition' },
	      items.map(function (item) {
	        return _react2.default.createElement(
	          'li',
	          { className: 'education__list-item', key: item.name },
	          _react2.default.createElement(_University2.default, item)
	        );
	      })
	    )
	  );
	};
	
	Education.defaultProps = {
	  items: [{
	    name: 'Carleton University',
	    link: 'https://admissions.carleton.ca/programs/interactive-multimedia-and-design-imd/',
	    degree: 'Bachelor of Information Technology',
	    location: 'Ottawa, Ontario, Canada',
	    duration: '2006-2010'
	  }, {
	    name: 'Algonquin College',
	    link: 'http://www.algonquincollege.com/mediaanddesign/program/bit-interactive-multimedia-and-design/',
	    degree: 'Diploma in Interactive Multimedia and Design',
	    location: 'Ottawa, Ontario, Canada',
	    duration: '2006-2010'
	  }, {
	    name: 'University of Saskatchewan',
	    link: 'https://www.usask.ca/',
	    degree: 'Arts and Science',
	    location: 'Saskatoon, Saskatchewan, Canada',
	    duration: '2004-2006'
	  }]
	};
	
	exports.default = Education;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// page-component---src-pages-education-js-b7bb1598d53228e1dc59.js